import React, { Component } from 'react';
import { withLiveClassModel } from 'components/LiveClass/components/LiveClassConsumer';
import LocalUserMedia from 'components/LiveClass/model-views/LocalUserMedia';
import JoinLiveClassPopup from 'components/LiveClass/model-views/JoinLiveClassPopup';
import EndLiveClassPopup from 'components/LiveClass/model-views/EndLiveClassPopup';
import MembersDrawer from 'components/LiveClass/model-views/MembersDrawer';
import ActivityPopup from 'components/LiveClass/model-views/ActivityPopup';
import ActivityDrawer from 'components/LiveClass/model-views/ActivityDrawer';

export default function withLiveClassElements(OriginalComponent) {
  @withLiveClassModel
  class LiveClassElements extends Component {
    componentWillUnmount() {
      const { liveClassModel } = this.props;
      liveClassModel.actions.leaveClass();
    }

    render() {
      return (
        <React.Fragment>
          <OriginalComponent {...this.props} />
          <LocalUserMedia />
          <JoinLiveClassPopup />
          <EndLiveClassPopup />
          <MembersDrawer />
          <ActivityPopup />
          <ActivityDrawer />
        </React.Fragment>
      );
    }
  }

  return LiveClassElements;
}
